import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, WritableSignal, signal } from '@angular/core';
import { GoogleMap, GoogleMapsModule, MapAdvancedMarker } from '@angular/google-maps';
import { TextFieldComponent } from '../text-field/text-field.component';

@Component({
  selector: 'app-maps-field',
  standalone: true,
  imports: [
    CommonModule,
    GoogleMapsModule,
    GoogleMap,
    MapAdvancedMarker,
    TextFieldComponent,
  ],
  templateUrl: './maps-field.component.html',
  styleUrl: './maps-field.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MapsFieldComponent implements OnInit, OnChanges {
  @Input() label: string = '';
  @Input() value: any;
  @Input() shapeComune?:any

  @ViewChild('myMap') map!: GoogleMap;
  center: WritableSignal<google.maps.LatLngLiteral> = signal({ lat: 41.8992, lng: 12.5450 });
  zoom = 7;
  options: google.maps.MapOptions = {
    mapTypeId: 'hybrid',
    tilt: 0,
    clickableIcons: false,
    disableDefaultUI: true,
    disableDoubleClickZoom: true,
    zoomControl: true,
    scrollwheel: false,
    gestureHandling: 'auto',
    keyboardShortcuts: false,
    fullscreenControl: false,
    mapTypeControl: false,
    streetViewControl: false

  }
  hasCoordinate = signal(false);
  coordinate: WritableSignal<google.maps.LatLngAltitudeLiteral | null> = signal(null);
  constructor(   private cdr : ChangeDetectorRef){}
  isValidJSON(str:any){
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  };
  ngOnInit(): void {
   
    if (this.value) {
      this.updateCoordinate(this.value['lat'], this.value['lng'], this.value['altitude'])
      this.hasCoordinate.set(true);
    } else {
      this.hasCoordinate.set(false);
    }

  }
  waitForMapInit(){
    return new Promise((resolve) => {
      const checkMap = setInterval(() => {
        if (this.map && this.map.googleMap) {
          clearInterval(checkMap);
          resolve(null);
        }
      }, 100); 
    });
  };
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('value') && !changes['value'].isFirstChange()) {
      
      if (changes['value'].currentValue !== null) {
        this.updateCoordinate(this.value['lat'], this.value['lng'], this.value['altitude'])
        this.hasCoordinate.set(true);
      } else {
        this.coordinate.set(null);
        this.hasCoordinate.set(false);
      }
    }
    this.waitForMapInit().then(() => {
      console.log('Mappa pronta');

      if(this.isValidJSON(this.shapeComune)){
        this.shapeComune=JSON.parse(this.shapeComune)
      }
      console.log(this.shapeComune);
      
      if (!this.map?.googleMap) return;
  
      const mapInstance = this.map.googleMap;
      

      try {
        this.map.googleMap.data.addGeoJson(this.shapeComune);
      } catch (e) {
        console.error("Errore caricamento GeoJSON", e);
      }
 
      mapInstance.data.setStyle((feature: any) => {
        const color = feature.getProperty('fillColor') || 'red'; // colore fallback
        return {
          fillColor: color,
          strokeColor: 'red',
          strokeWeight: 1,
       
        };
      });
      //this.cdr.detectChanges()
     // this.insertForm.get("myGeoJson")?.setValue(data)
      

     
    });

  }

  updateCoordinate(lat: number, lng: number, alt: number) {
    this.coordinate.set({
      lat: lat,
      lng: lng,
      altitude: alt
    });
    this.center.set({
      lat: lat,
      lng: lng,
    })
  }
}
